import { render, staticRenderFns } from "./OffsetTable1.vue?vue&type=template&id=4cd3e3b3&"
import script from "./OffsetTable1.vue?vue&type=script&lang=js&"
export * from "./OffsetTable1.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports